import React from 'react'
import PropTypes from 'prop-types'
import './pre-qualifying.css'

const PreQualifying = (props) => {
  return (
    <div id="prequalifying" className={`pre-qualifying-container1 ${props.rootClassName}`}>
      <div className="pre-qualifying-header">
        <div className="pre-qualifying-eyebrow">Get started</div>
        <h1 className="pre-qualifying-text1">Pre-Qualifying Assessment</h1>
        <p className="pre-qualifying-subtitle">Quick 2-minute form to check your eligibility — no commitment required.</p>
      </div>

      <form
        id="prequalifying-form"
        name="prequalifying"
        method="POST"
        action="https://test.helpmeout.co.za/api/pre-qualifying-assessment"
        data-form-id="e7e00d35-b8b1-47d7-ba1f-612c3b66d18a"
        encType="multipart/form-data"
        className="pre-qualifying-form"
      >
        {/* Honeypot */}
        <input type="text" id="home_honeypot" name="website" tabIndex="-1" spellCheck="false"
          autoCorrect="off" placeholder="Leave blank" autoComplete="new-password" autoCapitalize="off"
          aria-hidden="true" className="pre-qualifying-textinput1 input" />

        <div className="pre-qualifying-container2">
          <span className="pre-qualifying-text2">Are you currently under a formal debt review or debt counselling process?</span>
          <select id="home_debt_review" name="debt_review" required className="pre-qualifying-select1">
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>
        </div>

        <div className="pre-qualifying-container3">
          <span className="pre-qualifying-text3">Please indicate the number of bank accounts held in your name.</span>
          <input type="number" id="home_number_of_accounts" max={10} min={1} name="number_of_accounts"
            step={1} required placeholder="Accounts" className="pre-qualifying-textinput2" />
        </div>

        <div className="pre-qualifying-container4">
          <span className="pre-qualifying-text4">Accounts in use?</span>
          <input type="number" id="home_accounts_in_use" max={10} min={1} name="accounts_in_use"
            step={1} required placeholder="In Use" className="pre-qualifying-textinput3" />
        </div>

        <div className="pre-qualifying-container5">
          <span className="pre-qualifying-text5">Current employment status?</span>
          <select id="home_employment_status" name="employment_status" required className="pre-qualifying-select2">
            <option value="0">Unemployed</option>
            <option value="1">Permanent</option>
            <option value="2">Part Time</option>
            <option value="3">Self Employed</option>
          </select>
        </div>

        <div className="pre-qualifying-container6">
          <span className="pre-qualifying-text6">Please indicate your income payment frequency.</span>
          <select id="home_payment_frequency" name="payment_frequency" required defaultValue="3" className="pre-qualifying-select3">
            <option value="1">Weekly</option>
            <option value="2">Fortnightly</option>
            <option value="3">Monthly</option>
            <option value="4">Other</option>
          </select>
        </div>

        <div className="pre-qualifying-container7">
          <span className="pre-qualifying-text7">How many active loans do you currently have?</span>
          <input type="number" id="home_current_loans" max={10} min={0} name="current_loans"
            step={1} required placeholder="Current Loans" className="pre-qualifying-textinput4" />
        </div>

        <div className="pre-qualifying-container8">
          <span className="pre-qualifying-text8">Email Address</span>
          <input type="email" id="home_email" name="email" required
            placeholder="you@example.com" className="pre-qualifying-textinput5" />
        </div>

        <button name="button" type="submit" className="pre-qualifying-button button">
          Submit Assessment
        </button>
      </form>
    </div>
  )
}

PreQualifying.defaultProps = { rootClassName: '' }
PreQualifying.propTypes = { rootClassName: PropTypes.string }

export default PreQualifying
